﻿cb.define(['common/common_VM.Extend.js'], function (common) {
	var ST_st_othinrecord_VM_Extend = {
		doAction: function (name, viewmodel) {
			if (this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			debugger;
			//初始化barcode wangyda
			common.initBarcodeModel(viewmodel);
			//============================================================barcode related
			//扫码
			viewmodel.get("barcode").on('enter', function (data) {
				//字段对照
				var fields = {
					mainid: 'mainid',
					product: 'product',
					productcode: 'product_cCode',
					productname: 'product_cName',
					productsku: 'productsku',
					barcode: 'barcode',
					batchno: 'batchno',
					producedate: 'producedate',
					invaliddate: 'invaliddate',
					productskucode: 'productsku_cCode',
					weight: 'weight',
					quantity: 'quantity',
					unit: 'unit',
					unitname: 'product_unitName',//'',product_unitName
					// "accountWeight": 'accountWeight',
					// "accountPrice": pData.productskus[0].skuSalePrice,
					isbatch: 'isBatchManage'
				};
				return common.onBarCodeEnter(data, viewmodel, fields);

				// return common.onBarCodeEnter(data, viewmodel, rowObj, afterBarcodeEnter);
			});

			// var afterBarcodeEnter = function (result) {
			// 	debugger;
			// 	cb.utils.alert('afterBarcodeEnter');
			// 	return;

			// };
			//============================================================barcode related

			var detailsModel = viewmodel.get("othInRecords");
			if (detailsModel) {
				//向后台传递行号
				detailsModel.setState('orderField', 'rowno');
				detailsModel.on('rowColChange', function (args) {
					return common.bacthnoAndExpiryDateManage(args, detailsModel);
				});
				//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期
				detailsModel.on('afterCellValueChange', function (data) {
					switch (data.cellName) {
						case "product_cCode":
						case "product_cName": {
							detailsModel.setCellValue(data.rowIndex, 'batchno', null);
							detailsModel.setCellValue(data.rowIndex, 'producedate', null);
							detailsModel.setCellValue(data.rowIndex, 'invaliddate', null);
							break;
						}
					}
				})
				//单元格值改变以前
				detailsModel.on('beforeCellValueChange', function (data) {
					switch (data.cellName) {
						case "quantity": {
							if (data.value <= 0 || data.value == '-') {
								cb.utils.alert("[" + detailsModel.getColumn("quantity").cShowCaption + "]只能录入大于0的值，请检查后重试！");
								return false;
							}
							break;
						}
					}
				})
				//增行时，表头单据日期，带入表体入库日期
				detailsModel.on('beforeInsertRow', function (data) {
					debugger
					var vouchdate = this.getParent().get("vouchdate").getValue();
					data.row['recorddate'] = vouchdate;
				});
			}
			//保存之前
			viewmodel.on('beforeSave', function (args) {

			});
			//数据加载后
			viewmodel.on('afterLoadData', function () {

				if (cb.rest.AppContext.user.userType == 0) {
					viewmodel.get('store_name').setVisible(true);
				}
				else {
					viewmodel.get('store_name').setVisible(false);
				}
				var mode = viewmodel.getParams().mode;
				if (mode == "add")
					viewmodel.get("status").setVisible(false);
				else
					viewmodel.get("status").setVisible(true);

			});
		}
	}
	try {
		module.exports = ST_st_othinrecord_VM_Extend;
	} catch (error) {

	}
	return ST_st_othinrecord_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_othinrecord_VM.Extend.js